import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getStaffMembersSickDaysByYear } from "~/modules/absence/api/sickDay/sickDayApiDispatchers.ts";

export const sickDayQueries = {
	baseKey: ["sickDays"],
	byYear: (staffMemberId: string, year: number) =>
		queryOptions({
			queryKey: [...sickDayQueries.baseKey, { staffMemberId, year }],
			queryFn: () => getStaffMembersSickDaysByYear({ staffMemberId, year }).then(getDataFromResponse),
			enabled: !!staffMemberId,
		}),
};
